module.exports = __webpack_public_path__ + "img/m5-2.33d80e34.png";